import user from "../../data/actions/user";
import error from "../../data/actions/error";
import dimension from "../../data/actions/dimension";
import unhiddenActivitiesNames from "../../data/actions/unhiddenActivitiesName";
import todayDoneActivity from "../../data/actions/todayDoneActivity";
import unachievedGoals from "../../data/actions/unachievedGoals"
const actions = {
  user,
  error,
  dimension,
  unhiddenActivitiesNames,
  todayDoneActivity,
  unachievedGoals
};

export default actions;
